<div [@routeAnimations]="prepareRouter(outlet)" class="app-container">
    <router-outlet #outlet="outlet"></router-outlet>
</div>
<app-nav></app-nav>